export const BASE_URL = 'cost-centers';

export const PATHS = {
  BASE_URL,
};

export const COST_CENTERS_LIST_VIEW_STORAGE_KEY = 'costCentersListView';

export const COST_CENTER_CODE_MAX_LENGTH = 64;
export const COST_CENTER_NAME_MAX_LENGTH = 200;

/** Max size for contract attachment uploads (10 MB). Same ceiling as official document PDFs. */
export const COST_CENTER_CONTRACT_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;

/**
 * Sentinel accepted by report/search ops for the “Unassigned” bucket
 * (records stamped with a null cost center). Not a Firestore document id.
 */
export const COST_CENTER_UNASSIGNED_FILTER_VALUE = '__unassigned__';

/** URL / query param and filter field key shared by report dashboards. */
export const COST_CENTER_IDS_FILTER_KEY = 'costCenterIds';
